import { FC } from 'react';
import { SipTraceIndexContainer } from 'RtUi/app/rtSip/SipTrace/SipTrace.index';
import { SipTraceRouter } from 'RtUi/app/rtSip/SipTrace/SipTrace.router';

export const SipTraceIndexLcrContainer: FC = () => {
	return <SipTraceIndexContainer />;
};

SipTraceRouter.setIndexRtUiFunctionalComponent(SipTraceIndexLcrContainer, {});
